import type { FC } from "react";
import React from "react";
import type { ISVGIcon } from "../types";

export const ClearIcon: FC<ISVGIcon> = ({ className }) => {
  return (
    <svg
      className={className}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
    >
      <g
        id="PDA_Search_author_Spotlite"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        transform="translate(-227.000000, -57.000000)"
      >
        <g id="Search" transform="translate(10.000000, 51.000000)">
          <g id="Imput" transform="translate(1.000000, 0.000000)">
            <g id="icon_Clear" transform="translate(216.000000, 6.000000)">
              <circle id="Oval" fill="#D8D8D8" cx="8" cy="8" r="8" />
              <g
                id="Group-4"
                transform="translate(8.000000, 8.000000) rotate(-315.000000) translate(-8.000000, -8.000000) translate(4.000000, 4.000000)"
                stroke="#FFFFFF"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4,0.4 L4,7.6" id="Line" />
                <path d="M7.6,4 L0.4,4" id="Line" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
